import React, { Component } from 'react'

class CvcInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: '',
            valid: false
        };

        this.onChange = this.onChange.bind(this);
    }


    /**
     * Change and validate (numbers only, max 4 chars) the input fields' value
     * @param event
     */
    onChange = event => {
        const { value } = event.target;

        const shape = /^[0-9]+$/;
        const isNumber = value.length === 0 ? true :  value.match(shape);

        if(!isNumber || value.length > 4) {
            return;
        }

        this.setState({value});
        this.props.onChange(value);
    };

    render() {
        const {value} = this.state;

        return (
            <div className="position-relative">
                <input
                    className="form-control"
                    type="password"
                    inputMode="numeric"
                    pattern="\d*"
                    id="checkNumber"
                    autoComplete="cc-csc"
                    autoCorrect="off"
                    spellCheck="false"
                    value={value}
                    onChange={this.onChange}
                    onBlur={this.props.onBlur}
                    placeholder="CVC"
                />
            </div>
        )
    }
}

CvcInput.defaultProps = {
    onBlur: () => {
    },
    onChange: () => {
    }
};

export default CvcInput



// WEBPACK FOOTER //
// ./src/components/CreditCard/CvcInput/CvcInput.js